import {LocationDescriptorObject} from 'history';
import {PopupType} from '../store/popup';
import {SortDirection} from '../store/shared/types';

export enum QueryParameter {
    Popup = 'popup',
    BillingDocumentId = 'billingDocumentId',
    ServiceProviderId = 'serviceProviderId',
    VehicleId = 'vehicleId',
    Page = 'page',
    ItemsPerPage = 'itemsPerPage',
    SortColumn = 'sortColumn',
    Dashboard = 'dashboard',
    SortDirection = 'sortDirection',
    ReturnUrl = 'returnUrl',
    ServiceProviderNameContains = 'serviceProviderNameContains',
    DepotNameContains = 'depotNameContains',
    JobReferenceContains = 'jobReferenceContains',
    LicensePlateContains = 'licensePlateContains',
    FleetRefContains = 'fleetRefContains',
    BillingRefContains = 'billingRefContains',
    SkipMaintenance = 'skipMaintenance',
    JobId = 'jobId',
    SerialNumber = 'serialNumber',
    ScheduledReportId = 'scheduledReportId',
    JobTypeExclude = 'jobTypeExclude',
    IsEjobExclude = 'isEjobExclude'
}

export interface QueryParameterMap {
    popup?: PopupType;
    billingDocumentId?: string;
    serviceProviderId?: string;
    vehicleId?: string;
    jobId?: string;
    page?: number;
    dashboard?: string;
    itemsPerPage?: number;
    sortColumn?: string;
    sortDirection?: SortDirection;
    returnUrl?: string;
    reload?: boolean;
    serviceProviderNameContains?: string;
    serialNumber?: string;
    scheduledReportId?: string;
    jobTypeExclude?: string;
    isEjobExclude?: string;
}

export function buildSearchParameters(parameters: QueryParameterMap, search = ''): string {
    const queryParameters = new URLSearchParams(search);

    Object
        .keys(parameters)
        .map((k) => {
            if (parameters[k] !== undefined && parameters[k] !== '' && parameters[k]!==[]) {
                queryParameters.set(k, parameters[k]);
            } else {
                queryParameters.delete(k);
            }

            return undefined;
        });

    return queryParameters.toString();
}

export function buildReturnUrlFromQueryParameters(queryParameters: URLSearchParams): LocationDescriptorObject {
    const decodedReturnUrl = decodeURIComponent(queryParameters.get(QueryParameter.ReturnUrl)!);
    const splitReturnUrl = decodedReturnUrl.split('?');
    const pathname = splitReturnUrl[0];
    const search = splitReturnUrl.length === 2 ? splitReturnUrl[1] : '';
    return {pathname, search};
}
